import * as actionTypes from "../actionTypes/Index";
import { zonalConfigsInitilState } from "./InitialState";
import {
  IActionType,
  IFetchZonalConfigListActionResponse,
} from "../../interfaces/Index";

const initialState = { ...zonalConfigsInitilState };

export const appendUpdateZonalConfig = (
  payload: IFetchZonalConfigListActionResponse,
  state: any
) => {
  if (payload.isPaginatedRes) {
    return [...state.zonalConfigs, ...payload.zonalConfigsData];
  }
  return payload.zonalConfigsData.slice();
};

export default function zonalConfigsReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_ZONAL_CONFIGS_LIST_INIT: {
      return Object.assign({}, state, {
        isFetchZonalConfigsLoading: true,
        isFetchZonalConfigError: false,
        isZonalConfigAdded: false,
        isZonalConfigUpdated: false,
        error: null,
        isError: false,
      });
    }
    case actionTypes.GET_ZONAL_CONFIGS_LIST_SUCCESS: {
      return Object.assign({}, state, {
        isFetchZonalConfigsLoading: false,
        zonalConfigs: appendUpdateZonalConfig(action.payload as any, state),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.GET_ZONAL_CONFIGS_LIST_FAIL: {
      return Object.assign({}, state, {
        isFetchZonalConfigsLoading: false,
        isFetchZonalConfigError: true,
        error: action.error,
      });
    }

    case actionTypes.GET_ZONAL_CONFIG_CHANNEL_INIT: {
      return Object.assign({}, state, {
        isFetchCustomerChannelLoading: true,
        isError: false,
        zonalConfigChannelName: null,
        error: null,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_CHANNEL_SUCCESS: {
      return Object.assign({}, state, {
        isFetchCustomerChannelLoading: false,
        zonalConfigChannelName: action.payload,
        isError: false,
        error: null,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_CHANNEL_FAIL: {
      return Object.assign({}, state, {
        isFetchCustomerChannelLoading: false,
        zonalConfigChannelName: null,
        isError: true,
        error: action.error,
      });
    }

    //zonal boundaries
    case actionTypes.ZONAL_CONFIG_UPLOAD_INIT: {
      return Object.assign({}, state, {
        isZonalConfigUploading: true,
        isZonalConfigUploadingError: false,
        isZonalConfigUploaded: false,
        isZonalConfigDetailsFetched: false,
        error: null,
      });
    }
    case actionTypes.ZONAL_CONFIG_UPLOAD_SUCCESS: {
      return Object.assign({}, state, {
        isZonalConfigUploading: false,
        isZonalConfigUploaded: true,
      });
    }
    case actionTypes.ZONAL_CONFIG_UPLOAD_FAIL: {
      return Object.assign({}, state, {
        isZonalConfigUploading: false,
        isZonalConfigUploadingError: true,
        isZonalConfigUploaded: false,
        error: action.error,
      });
    }

    case actionTypes.CREATE_ZONAL_CONFIG_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isZonalConfigAdded: false,
        error: null,
      });
    }
    case actionTypes.CREATE_ZONAL_CONFIG_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isZonalConfigAdded: true,
      });
    }
    case actionTypes.CREATE_ZONAL_CONFIG_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isZonalConfigAdded: false,
        error: action.error,
      });
    }
    case actionTypes.UPDATE_ZONAL_CONFIG_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isZonalConfigUpdated: false,
        error: null,
        isZonalConfigAdded: false,
      });
    }
    case actionTypes.UPDATE_ZONAL_CONFIG_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isZonalConfigUpdated: true,
        zonalConfigDetails: [],
        isZonalConfigDetailsFetched: false,
      });
    }
    case actionTypes.UPDATE_ZONAL_CONFIG_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isZonalConfigUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.CLEAR_ZONAL_CONFIG_DETAILS: {
      return Object.assign({}, state, {
        zonalConfigDetails: [],
        isZonalConfigDetailsFetched: false,
        isError: false,
        error: null,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isWarehouseCategoriesFetched: false,
        warehouseCategories: [],
        error: null,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isWarehouseCategoriesFetched: true,
        warehouseCategories: (action.payload! as Array<any>).slice(),
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isWarehouseCategoriesFetched: false,
        error: action.error,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_CHILD_ZONES_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isZonalConfigChildZonesFetched: false,
        zonalConfigChildZones: null,
        error: null,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_CHILD_ZONES_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isZonalConfigChildZonesFetched: true,
        zonalConfigChildZones: action.payload,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_CHILD_ZONES_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isZonalConfigChildZonesFetched: false,
        error: action.error,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_TOWNS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isZonalConfigTownsFetched: false,
        zonalConfigTowns: null,
        error: null,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_TOWNS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isZonalConfigTownsFetched: true,
        zonalConfigTowns: action.payload,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_TOWNS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isZonalConfigTownsFetched: false,
        error: action.error,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_NAME_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isZonalConfigWarehouseNameFetched: false,
        zonalConfigWarehouseName: null,
        error: null,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_NAME_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isZonalConfigWarehouseNameFetched: true,
        zonalConfigWarehouseName: action.payload,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_NAME_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isZonalConfigWarehouseNameFetched: false,
        error: action.error,
      });
    }
    case actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_LIST_WITH_STORAGE_BLOCKS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isZonalConfigWarehouseListWithStorageBlocksFetched: false,
        zonalConfigWarehouseListWithStorageBlocks: null,
        error: null,
      });
    }

    case actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_LIST_WITH_STORAGE_BLOCKS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isZonalConfigWarehouseListWithStorageBlocksFetched: true,
        zonalConfigWarehouseListWithStorageBlocks: action.payload
      });
    }

    case actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_LIST_WITH_STORAGE_BLOCKS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isZonalConfigWarehouseListWithStorageBlocksFetched: false,
        error: action.error,
      });
    }

    default:
      return state;
  }
}
